export const formatCurrency = (amount: number, minFractionDigits?: number, maxFractionDigits?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minFractionDigits ?? 2,
    maximumFractionDigits: maxFractionDigits ?? 2
  })

  return formatter.format(amount)
}

export const formatNumber = (value: number, minFractionDigits?: number, maxFractionDigits?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minFractionDigits ?? 2,
    maximumFractionDigits: maxFractionDigits ?? 2
  })

  return formatter.format(value)
}

export const toExcelLetter = (index: number): string => {
  let result = ''
  let n = index
  do {
    result = String.fromCharCode(65 + (n % 26)) + result
    n = Math.floor(n / 26) - 1
  } while (n >= 0)
  return result
}

export const formatPercentage = (value: number, minFractionDigits?: number, maxFractionDigits?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: minFractionDigits ?? 2,
    maximumFractionDigits: maxFractionDigits ?? 2
  })

  return formatter.format(value)
}

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '')
  const match = cleaned.match(/(\d{3})(\d{3})(\d{4})/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return phoneNumber
}
